import {
	StyleSheet,
} from "react-native";
import xtend from "xtend";

import Style from "@aetonix/styles";

var structural = {
	position: "relative",
	borderRadius: 0,
	backgroundColor: Style.look.sectionBackground,
	borderColor: Style.look.sectionOutline,
	borderWidth: 1,
	borderStyle: "solid",
	// Subtract 1 to account for border
	padding: Style.layout.paddingSmall - 1
};
var subFormContainer = {
	borderWidth: 1,
	borderColor: Style.look.sectionOutline,
	borderStyle: "solid",
	marginVertical: Style.layout.marginSmall,
	padding: Style.layout.paddingSmall
};

var errored = {
	backgroundColor: Style.look.alertBackground,
	borderColor: Style.look.alert
};

var contrast = {
	backgroundColor: Style.colors.black,
	borderRadius: Style.layout.atouchaway.inputBorder,
	borderWidth: 3,
	borderColor: Style.colors.tertiary,
};

var textual = xtend(structural, {
	color: Style.look.text,
	fontSize: Style.text.standard,
});

var styles = StyleSheet.create({
	input: textual,
	container: structural
});

export default {
	style: styles.input,
	raw: textual,
	container: styles.container,
	errored: errored,
	subFormContainer: subFormContainer,
	contrast: contrast
};
